'use es6';

import getIn from 'transmute/getIn';
import { createSelector } from 'reselect';
import { getEntries } from 'conversations-async-data/indexed-async-data/operators/getters';
import { getFocusedThreadVisitorId } from '../../visitor/selectors/getFocusedThreadVisitorId';
import { getIndexedAsyncVisitors } from 'conversations-thread-data/visitor/selectors/getIndexedAsyncVisitors';
export const getFocusedThreadVisitorEmailAddress = createSelector([getFocusedThreadVisitorId, getIndexedAsyncVisitors], (threadVisitorId, asyncVisitors) => {
  return getIn([`${threadVisitorId}`, 'data', 'email'], getEntries(asyncVisitors));
});